const Slideshow = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 1,
        variableWidth: false,
        arrows: false,
        dots: true,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default Slideshow;



// WEBPACK FOOTER //
// ./scripts/components/Slideshow.js